export default "__VITE_ASSET__31452053__"